import { Injectable } from '@angular/core';
import { EntityState, StoreConfig, Store } from '@datorama/akita';
import { RegistrationPurchaseBasket } from './models/registration-purchase-basket';

export interface RegistrationBasketState extends EntityState<RegistrationPurchaseBasket> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'registration-basket' })
export class RegistrationBasketStore extends Store<RegistrationBasketState> {

  constructor() {
    super({});
  }

}

